const SESSION_HEADER = "X-Education-Session"

/** `{ headers: { "X-Education-Session": session } }` — same shape
 *  `SigningPage/api/signing.client.ts`'s `withSession` returns for
 *  `X-Esign-Session`, so every call site reads the same way. */
export const withEducationSession = (session: string) => ({
  headers: { [SESSION_HEADER]: session }
})
